import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NDCDetails } from 'src/app/models/NDCDetails';
import { Observable } from 'rxjs';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { IProcedureFee } from 'src/app/models/IProcedureFee';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { IInsuranceCarriers } from 'src/app/models/IInsuranceCarriers';
import { IProviderIdentities } from 'src/app/models/IProviderIdentities';
import { configuration } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  constructor(private http: HttpClient) { }

  //Save NDC Details
  saveManageNDCDetails(NDCInfo: NDCDetails): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Master/NDC'}`, NDCInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  //Get NDC Details
  getManageNDCDetials(facilityId: number): Observable<NDCDetails[]> {
    return this.http.get<NDCDetails[]>(`${configuration.apiUrl + 'Master/NDC'}?facilityId=${sessionStorage.getItem("FacilityId")}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

 //Get All ProcedureFee Details
  getProcedureFee(): Observable<IProcedureFee[]> {
    return this.http.get<IProcedureFee[]>(`${configuration.apiUrl + 'Master/ProcedureFee'}`);
  }

  //Get Provider Details by UserId 
  getProviderDetialsByUser(userid: string): Observable<IUserDetails> {
    return this.http.get<IUserDetails>(
      `${configuration.apiUrl + 'Admin/Providers'}?userid=${userid}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  updateProviderDetails(userInfo: IUserDetails): Observable<IUserDetails> {
    return this.http.post<IUserDetails>(`${configuration.apiUrl + 'Admin/Provider'}`, userInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  
  getInsCarriers(): Observable<IInsuranceCarriers[]> {
    return this.http.get<IInsuranceCarriers[]>(`${configuration.apiUrl + 'Master/ActivePayers'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  updateProviderEntityDetails(payerInfo: IProviderIdentities): Observable<IProviderIdentities> {
    return this.http.post<IProviderIdentities>(`${configuration.apiUrl + 'Admin/ProviderIdentities'}`, payerInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getProviderEntityDetialsByUser(userid: string): Observable<IProviderIdentities[]> {
    return this.http.get<IProviderIdentities[]>(
      `${configuration.apiUrl + 'Admin/ProviderIdentities'}?userid=${userid}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }
 
}
